import React from "react";

function Hint(props) {
  const { children } = props;
  return <div className='hint'>{children}</div>;
}

export default Hint;
